import { Injectable } from '@angular/core';
import { AbstractService } from '@increff/commons';
import { Rest } from './rest.service';

@Injectable()
export class ApiService {
    constructor(private abstractService: AbstractService, private rest: Rest) { }
}
